module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("gITLb"))).then(() => parcelRequire('7m5yQ'));